import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListBullet12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconListBullet12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m8.009.5a.5.5 0 1 0 0-1H4.487a.5.5 0 0 0 0 1zm-1.39 3a.5.5 0 1 0 0-1H4.487a.5.5 0 1 0 0 1zm1.89 2.5a.5.5 0 0 1-.5.5H4.487a.5.5 0 0 1 0-1h6.022a.5.5 0 0 1 .5.5M9.119 11a.5.5 0 0 0 0-1H4.487a.5.5 0 0 0 0 1zM1.75 5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M2.5 7.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListBullet12);
